import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale, getRandomInRange, getRandomRGBColor } from "./utils";

const Color = require("color");

class CanvasColorBars extends LitElement {
    static get properties() {
        return {
            source: { type: String },
            position: { type: String },
            height: { type: Number },
            width: { type: Number },
            startColor: { type: Array },
            endColor: { type: Array },
            numNotes: { type: Number },
            fade: { type: Number },
            id: { type: String },
        };
    }

    constructor() {
        super();

        this.source = "Arturia MINILAB";
        this.position = "absolute";
        this.numNotes = 8;
        this.noteCount = 0;
        this.startColor = [255, 0, 0];
        this.endColor = [0, 0, 255];
        this.fade = 0;

        WebMidi.enable((error) => {
            if (error) {
                console.log(error);
            } else {
                const midiSource = WebMidi.getInputByName(this.source);
                midiSource.addListener("noteon", "all", this.draw.bind(this));
                midiSource.addListener("noteoff", "all", this.clear.bind(this));
            }
        });
    }

    handleNoteOn(e) {
        console.log(e);
        const note = e.note;
        this.draw(note);
    }

    handleNoteOff(e) {
        const note = e.note;
        this.clear(note);
    }

    draw(note) {
        const canvas = this.shadowRoot.querySelector("canvas");

        if (canvas) {
            const context = canvas.getContext("2d");
            context.globalCompositeOperation = "multiply";

            // set canvas size
            const height = window.innerHeight;
            const width = window.innerWidth;
            canvas.width = width;
            canvas.height = height;

            // set color
            const factor = scale(this.noteCount, 0, this.numNotes, 0, 1);
            const color = Color.rgb(this.startColor);
            const mixedColor = color.mix(Color.rgb(this.endColor), factor);
            const fadedColor = mixedColor.fade(this.fade);

            context.fillStyle = fadedColor;

            const elementWidth = canvas.width;
            const elementHeight = canvas.height / this.numNotes;
            // (canvas.height / numNotes) * noteCount
            const elementX = 0;
            const elementY = (canvas.height / this.numNotes) * this.noteCount;
            context.fillRect(0, elementY, elementWidth, elementHeight);

            if (this.noteCount >= this.numNotes - 1) {
                this.noteCount = 0;
            } else {
                this.noteCount += 1;
            }

            // window.requestAnimationFrame(this.log);
        }
    }

    clear(note) {
        const canvas = this.shadowRoot.querySelector("canvas");
        if (canvas) {
            const context = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
        }
    }

    log() {
        console.log("frame");
    }

    render() {
        return html`
            <style>
                #container {
                    position: ${this.position};
                }
            </style>
            <div id="container"><canvas id="${this.id}"></canvas></div>
        `;
    }
}

customElements.define("canvas-color-bars", CanvasColorBars);
